/* cl-ui.js — camada interativa do clone cellumove-6 (vanilla; sem custom elements/Swiper/Flickity do Impact).
   - trilhos [data-cl-track]: scroll nativo (dedo no mobile, arrasto de mouse no desktop); itens =
     data-cl-item; setas [data-cl-prev]/[data-cl-next] (ou button[aria-controls=<id do trilho>]) andam um
     item e desabilitam nas pontas; .ce-scroll-progress[observes=<id>] recebe --scroll-progress.
   - cards do Impact: swatch troca a foto; [data-cl-quick-add=<handle>] abre o seletor rapido (opcoes do
     NOSSO produto via /products/<handle>.js) e adiciona ao carrinho.
   - carrinho: icone do header e todo form /cart/add abrem a gaveta (secao cl-cart-drawer).
   - <details> copiados: aria-expanded acompanha o estado. */
(function () {
  'use strict';
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------- trilhos ---------------- */
  function items(track) {
    var sel = track.getAttribute('data-cl-item');
    var list = sel && sel !== '*' ? $$(sel, track) : Array.prototype.slice.call(track.children);
    return list.filter(function (c) { return c.nodeType === 1 && c.tagName !== 'STYLE' && c.tagName !== 'SCRIPT' && c.offsetWidth > 0; });
  }
  function offsetIn(track, el) {
    return el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
  }
  function index(track) {
    var it = items(track); if (!it.length) return 0;
    var base = offsetIn(track, it[0]), best = 0, bd = 1e9;
    it.forEach(function (e, k) { var d = Math.abs(offsetIn(track, e) - base - track.scrollLeft); if (d < bd) { bd = d; best = k; } });
    return best;
  }
  function go(track, i) {
    var it = items(track); if (!it.length) return;
    i = Math.max(0, Math.min(it.length - 1, i));
    var max = track.scrollWidth - track.clientWidth;
    var left = Math.min(offsetIn(track, it[i]) - offsetIn(track, it[0]), max);
    track.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
  }
  function controls(track) {
    var id = track.id, r = track.closest('[class*="cl-sec-"], [class*="cl-pdp-"], .cl-cart-drawer') || document;
    var prev = $$('[data-cl-prev]', r).filter(function (b) { return !id || !b.getAttribute('aria-controls') || b.getAttribute('aria-controls') === id; });
    var next = $$('[data-cl-next]', r).filter(function (b) { return !id || !b.getAttribute('aria-controls') || b.getAttribute('aria-controls') === id; });
    var bars = id ? $$('[observes="' + id + '"]') : [];
    return { prev: prev, next: next, bars: bars, root: r };
  }
  function paint(track, c) {
    var max = track.scrollWidth - track.clientWidth;
    // media-carousel adaptive-height do Impact: altura = a da midia atual (so quando e carrossel)
    if (track.hasAttribute('adaptive-height')) {
      var it = items(track), cur = it[index(track)];
      if (max > 1 && cur) track.style.maxHeight = cur.getBoundingClientRect().height + 'px';
      else track.style.maxHeight = '';
    }
    c.prev.forEach(function (b) { if (track.scrollLeft <= 1) b.setAttribute('disabled', ''); else b.removeAttribute('disabled'); });
    c.next.forEach(function (b) { if (track.scrollLeft >= max - 1) b.setAttribute('disabled', ''); else b.removeAttribute('disabled'); });
    var p = track.scrollWidth ? Math.max(0, Math.min(1, (track.scrollLeft + track.clientWidth) / track.scrollWidth)) : 1;
    c.bars.forEach(function (b) { b.style.setProperty('--scroll-progress', p.toFixed(6)); });
    var dots = c.root.querySelector && c.root.querySelector('[data-cl-dots]');
    if (dots) { var i = index(track); Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-selected', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); }); }
  }
  function initTrack(track) {
    if (track.__cl) return; track.__cl = true;
    var c = controls(track);
    c.prev.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); go(track, index(track) - 1); }); });
    c.next.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); go(track, index(track) + 1); }); });
    var dots = c.root.querySelector && c.root.querySelector('[data-cl-dots]');
    if (dots) Array.prototype.forEach.call(dots.children, function (d, k) { d.addEventListener('click', function () { go(track, k); }); });
    var tick;
    track.addEventListener('scroll', function () { cancelAnimationFrame(tick); tick = requestAnimationFrame(function () { paint(track, c); }); }, { passive: true });
    window.addEventListener('resize', function () { paint(track, c); });
    paint(track, c);
    // arrastar com o mouse (o toque e nativo)
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || track.scrollWidth <= track.clientWidth + 2) return;
      down = true; moved = false; sx = e.pageX; sl = track.scrollLeft;
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - sx;
      if (Math.abs(dx) > 5) { moved = true; track.classList.add('cl-dragging'); }
      if (moved) { track.scrollLeft = sl - dx; e.preventDefault(); }
    });
    window.addEventListener('mouseup', function () {
      if (!down) return; down = false;
      if (moved) { track.classList.remove('cl-dragging'); go(track, index(track)); }
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    $$('a, img', track).forEach(function (a) { a.setAttribute('draggable', 'false'); });
  }
  function initTracks(scope) { $$('[data-cl-track]', scope).forEach(initTrack); }

  /* ---------------- cards: swatches ---------------- */
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp.matches || !inp.matches('.product-card__swatch-list input[type=radio], .ce-product-card input[type=radio]')) return;
    var card = inp.closest('.ce-product-card'); if (!card) return;
    var m1 = inp.getAttribute('data-cl-media'), m2 = inp.getAttribute('data-cl-media2');
    var p = card.querySelector('.product-card__image--primary'), s = card.querySelector('.product-card__image--secondary');
    if (m1 && p) { p.removeAttribute('srcset'); p.src = m1; }
    if (m2 && s) { s.removeAttribute('srcset'); s.src = m2; }
    card.__clColor = (inp.closest('label') || card.querySelector('label[for="' + inp.id + '"]') || {}).textContent;
    var lab = card.querySelector('label[for="' + inp.id + '"]');
    card.__clColor = lab ? lab.textContent.trim() : '';
  });

  /* ---------------- quick add ---------------- */
  var money = function (c) {
    var f = (window.clMoneyFormat || (window.Shopify && Shopify.money_format) || '${{amount}}');
    var v = (c / 100).toFixed(2);
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100));
  };
  function addToCart(id, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1 }] }) }).then(function (r) { return r.json(); });
  }
  window.clAddToCart = addToCart;
  function quickModal(product, preColor, opener) {
    var old = document.getElementById('cl-quick'); if (old) old.remove();
    var sel = product.options.map(function (o, k) {
      var vals = o.values; var pick = vals[0];
      if (preColor && vals.indexOf(preColor) >= 0) pick = preColor;
      return pick;
    });
    var w = document.createElement('div'); w.id = 'cl-quick'; w.className = 'cl-quick'; w.setAttribute('role', 'dialog'); w.setAttribute('aria-modal', 'true');
    w.innerHTML = '<div class="cl-quick__bg" data-x></div><div class="cl-quick__box"><button type="button" class="cl-quick__x" data-x aria-label="Close">&times;</button>' +
      '<div class="cl-quick__top"><img alt=""><div><p class="cl-quick__t"></p><p class="cl-quick__p"></p></div></div><div class="cl-quick__opts"></div>' +
      '<button type="button" class="cl-quick__add">Add to cart</button></div>';
    document.body.appendChild(w);
    w.querySelector('.cl-quick__t').textContent = product.title;
    var opts = w.querySelector('.cl-quick__opts');
    product.options.forEach(function (o, k) {
      var g = document.createElement('div'); g.className = 'cl-quick__g';
      g.innerHTML = '<p class="cl-quick__l"></p><div class="cl-quick__vs"></div>';
      g.querySelector('.cl-quick__l').textContent = o.name;
      o.values.forEach(function (v) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'cl-quick__v'; b.textContent = v;
        b.addEventListener('click', function () { sel[k] = v; render(); });
        g.querySelector('.cl-quick__vs').appendChild(b);
      });
      opts.appendChild(g);
    });
    function variant() { return product.variants.filter(function (v) { return v.options.every(function (x, k) { return x === sel[k]; }); })[0]; }
    function render() {
      var v = variant();
      $$('.cl-quick__g', w).forEach(function (g, k) { $$('.cl-quick__v', g).forEach(function (b) { b.classList.toggle('is-on', b.textContent === sel[k]); }); });
      var img = (v && v.featured_image && v.featured_image.src) || product.featured_image;
      if (img) w.querySelector('img').src = img + (img.indexOf('?') > 0 ? '&' : '?') + 'width=240';
      w.querySelector('.cl-quick__p').innerHTML = v ? money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '') : '';
      var add = w.querySelector('.cl-quick__add');
      add.disabled = !v || !v.available; add.textContent = !v ? 'Unavailable' : (v.available ? 'Add to cart' : 'Sold out');
    }
    render();
    function close() { w.remove(); if (opener) opener.focus(); }
    $$('[data-x]', w).forEach(function (x) { x.addEventListener('click', close); });
    w.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    w.querySelector('.cl-quick__add').addEventListener('click', function () {
      var v = variant(); if (!v) return;
      this.setAttribute('aria-busy', 'true');
      addToCart(v.id, 1).then(function () { close(); openCart(); });
    });
    w.querySelector('.cl-quick__x').focus();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cl-quick-add]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-cl-quick-add'); if (!h) return;
    var card = b.closest('.ce-product-card');
    var checked = card && card.querySelector('input[type=radio]:checked');
    var color = card && (card.__clColor || (checked && (card.querySelector('label[for="' + checked.id + '"]') || {}).textContent || '').trim());
    fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.json(); }).then(function (p) {
      if (p.variants.length === 1) { return addToCart(p.variants[0].id, 1).then(openCart); }
      quickModal(p, color, b);
    });
  }, true);

  /* ---------------- carrinho ---------------- */
  function openCart() { document.dispatchEvent(new CustomEvent('cl:cart:open')); }
  window.clOpenCart = openCart;
  document.addEventListener('click', function (e) {
    if (!document.querySelector('[data-cl-cart-drawer]')) return;
    var a = e.target.closest && e.target.closest('a[href="/cart"], a[href$="/cart"], cart-icon, .header-actions__cart-icon, [data-cl-cart-toggle], button[aria-controls="cart-drawer"]');
    if (!a || a.closest('[data-cl-cart-drawer]')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    openCart();
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!document.querySelector('[data-cl-cart-drawer]') || form.hasAttribute('data-cl-native-submit')) return;
    var kroot = form.closest('[data-cl-pdp-root]');
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    // app Kaching no slot do buybox: o lote e o do proprio app (linhas por variante, __kaching_bundles, brindes);
    // ?kaching_bundles=true = o embed nao re-intercepta este POST
    var kb = kroot && kroot.querySelector('[data-cl-app-slot] kaching-bundles-block'), its = null;
    if (kb && typeof kb.items === 'function') { try { its = kb.items(); } catch (err) { its = null; } }
    var req = its && its.length
      ? fetch('/cart/add.js?kaching_bundles=true', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: its }) })
      : fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } });
    req
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.status && d.description) { alert(d.description); return; } openCart(); })
      .catch(function () {})
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }, true);

  /* ---------------- <details> ---------------- */
  function syncDetails(scope) {
    $$('[class*="cl-sec-"] details, [class*="cl-pdp-"] details', scope).forEach(function (d) {
      if (d.__clBound) return; d.__clBound = true;
      var s = d.querySelector('summary'); if (!s) return;
      var own = d.hasAttribute('aria-expanded');
      function sync() { s.setAttribute('aria-expanded', d.open ? 'true' : 'false'); if (own) d.setAttribute('aria-expanded', d.open ? 'true' : 'false'); }
      sync(); d.addEventListener('toggle', sync);
    });
  }

  /* videos com autoplay (o atributo vem do HTML servido; o play() garante no iOS) */
  function videos() {
    $$('[class*="cl-sec-"] video[autoplay], [class*="cl-pdp-"] video[autoplay]').forEach(function (v) {
      v.muted = true; var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  /* overflow-list do Horizon: com o wrap do cl-global nenhum item precisa ir para "More" */
  function menuAll() {
    $$('#header-component overflow-list').forEach(function (ol) {
      function all() { if (typeof ol.showAll === 'function' && ol.querySelector('[slot="overflow"]')) { try { ol.showAll(); } catch (e) {} } }
      all();
      new MutationObserver(all).observe(ol, { subtree: true, attributes: true, attributeFilter: ['slot'] });
    });
  }

  /* preco do ATC copiado ("ADD TO CART — $X") = preco da barra selecionada do app Kaching no slot */
  function kachingPrice() {
    $$('[data-cl-pdp-root]').forEach(function (root) {
      var slot = root.querySelector('[data-cl-app-slot]'), span = root.querySelector('[data-cl-kit-price]');
      if (!slot || !span || slot.__clPrice) return; slot.__clPrice = true;
      var orig = span.textContent, t = null;
      function paint() {
        var b = slot.querySelector('.kaching-bundles__bar--selected') || slot.querySelector('.kaching-bundles__bar');
        var pr = b && b.querySelector('.kaching-bundles__bar-price');
        if (!pr) return;                                  // sem barras: o preco e o da variante (cl-vfb)
        var txt = pr.textContent.trim();
        if (txt && span.textContent !== txt) span.textContent = txt;
      }
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(paint, 60); })
        .observe(slot, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      paint();
    });
  }

  /* seletor de reserva (snippets/cl-vfb): produto sem deal no app -> o app nao desenha barras e o buybox dele
     nao tem seletor proprio. Aparece quando nao ha .kaching-bundles__bar depois do load; liga as opcoes ao
     input id do form e ao preco do ATC. Se o app desenhar depois, some. */
  function variantFallback() {
    $$('[data-cl-vfb]').forEach(function (box) {
      if (box.__cl) return; box.__cl = true;
      var slot = box.closest('[data-cl-app-slot]'), root = box.closest('[data-cl-pdp-root]') || document;
      var input = root.querySelector('form[data-cl-pdp-form] [data-cl-variant-id]');
      var btn = root.querySelector('form[data-cl-pdp-form] [type="submit"]');
      var span = root.querySelector('.clm-atc-price');
      var variants = [];
      try { variants = JSON.parse(box.querySelector('[data-cl-vfb-variants]').textContent); } catch (e) {}
      var sels = $$('select[data-cl-vfb-opt]', box);
      function sync() {
        var vals = sels.map(function (s) { return s.value; });
        var v = variants.filter(function (x) { return x.options.every(function (o, k) { return o === vals[k]; }); })[0];
        if (input && v) input.value = v.id;
        if (span && v) span.textContent = money(v.price);
        if (btn) btn.disabled = !v || !v.available;
      }
      sels.forEach(function (s) { s.addEventListener('change', sync); });
      function decide() {
        var bars = slot && slot.querySelector('.kaching-bundles__bar');
        var show = !bars;
        if (box.hidden === !show) return;
        box.hidden = !show;
        if (show) sync(); else if (btn) btn.disabled = false;
      }
      function later() { setTimeout(decide, 2500); }
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
      if (slot) new MutationObserver(function () { if (!box.hidden && slot.querySelector('.kaching-bundles__bar')) decide(); })
        .observe(slot, { subtree: true, childList: true });
    });
  }

  /* modais dele com "portal" (Fit finder cm-ff, size guide sg-): o script move o overlay para o <body>, fora do
     wrapper .cl-pdp-<key> -> o CSS escopado deixa de valer (overlay static no fim da pagina, "sem acao").
     Eles vao para um conteiner com a classe do escopo (display:contents) DENTRO do body: as referencias do
     script continuam validas e as regras .cl-pdp-<key> .cm-ff__overlay voltam a casar. */
  var PORTAL = '.cm-ff__overlay, [data-ff-overlay], .sg-overlay, [data-sg-root]';
  function portals() {
    var wrap = document.querySelector('[data-cl-pdp-root] [class^="cl-pdp-"]');
    var scope = wrap && (wrap.className.match(/(?:^|\s)(cl-pdp-[\w-]+)/) || [])[1];
    if (!scope) return;
    var box = null;
    function adopt() {
      Array.prototype.forEach.call(document.body.children, function (el) {
        if (!el.matches || !el.matches(PORTAL)) return;
        if (!box) {
          box = document.createElement('div');
          box.className = scope + ' cl-portal';
          box.setAttribute('style', 'display: contents !important;');
          document.body.appendChild(box);
        }
        box.appendChild(el);
      });
    }
    adopt();
    new MutationObserver(adopt).observe(document.body, { childList: true });
  }

  function boot() { portals(); initTracks(); syncDetails(); videos(); kachingPrice(); variantFallback(); if (window.matchMedia('(min-width: 990px)').matches) menuAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.clInitTracks = initTracks;
  window.clSyncDetails = syncDetails;
})();
